import React from 'react';

// Service page imports
import KeyPersonInsurance from '../pages/services/KeyPersonInsurance';
import CharitableLegacyPlanning from '../pages/services/CharitableLegacyPlanning';
import IfaStrategy from '../pages/services/IfaStrategy';
import TermLifeInsurance from '../pages/services/TermLifeInsurance';
import DisabilityInsurance from '../pages/services/DisabilityInsurance';
import CriticalIllnessInsurance from '../pages/services/CriticalIllnessInsurance';
import GroupBenefitsPolicies from '../pages/services/GroupBenefitsPolicies';
import WholeLifeInsurance from '../pages/services/WholeLifeInsurance';
import ParticipatingWholeLifeInsurance from '../pages/services/ParticipatingWholeLifeInsurance';
import UniversalLifeInsurance from '../pages/services/UniversalLifeInsurance';
import Tfsa from '../pages/services/Tfsa';
import Rrsp from '../pages/services/Rrsp';
import Rrif from '../pages/services/Rrif';
import Hisa from '../pages/services/Hisa';
import Annuities from '../pages/services/Annuities';
import BuySellAgreementFunding from '../pages/services/BuySellAgreementFunding';
import GiantTfsaTaxExemptPolicies from '../pages/services/GiantTfsaTaxExemptPolicies';
import InsuredRetirementStrategy from '../pages/services/InsuredRetirementStrategy';
import EstatePreservation from '../pages/services/EstatePreservation';

interface RouteConfig {
  path: string;
  element: React.ReactNode;
}

export const serviceRoutes: RouteConfig[] = [
  // Insurance Products
  {
    path: "/services/term-life-insurance",
    element: <TermLifeInsurance />,
  },
  {
    path: "/services/whole-life-insurance",
    element: <WholeLifeInsurance />,
  },
  {
    path: "/services/participating-whole-life-insurance",
    element: <ParticipatingWholeLifeInsurance />,
  },
  {
    path: "/services/universal-life-insurance",
    element: <UniversalLifeInsurance />,
  },
  {
    path: "/services/disability-insurance",
    element: <DisabilityInsurance />,
  },
  {
    path: "/services/critical-illness-insurance",
    element: <CriticalIllnessInsurance />,
  },
  {
    path: "/services/group-benefits-policies",
    element: <GroupBenefitsPolicies />,
  },
  {
    path: "/services/key-person-insurance",
    element: <KeyPersonInsurance />,
  },

  // Wealth Building
  {
    path: "/services/tax-free-savings-account-tfsa",
    element: <Tfsa />,
  },
  {
    path: "/services/registered-retirement-savings-plan-rrsp",
    element: <Rrsp />,
  },
  {
    path: "/services/registered-retirement-income-fund-rrif",
    element: <Rrif />,
  },
  {
    path: "/services/high-interest-savings-accounts-hisa",
    element: <Hisa />,
  },
  {
    path: "/services/annuities",
    element: <Annuities />,
  },

  // Advanced Strategies
  {
    path: "/services/insured-retirement-strategy-irs",
    element: <InsuredRetirementStrategy />,
  },
  {
    path: "/services/insured-retirement-strategy",
    element: <InsuredRetirementStrategy />,
  },
  {
    path: "/services/estate-preservation",
    element: <EstatePreservation />,
  },
  {
    path: "/services/buy-sell-agreement-funding",
    element: <BuySellAgreementFunding />,
  },
  {
    path: "/services/giant-tfsa-tax-exempt-policies",
    element: <GiantTfsaTaxExemptPolicies />,
  },
  {
    path: "/services/charitable-legacy-planning",
    element: <CharitableLegacyPlanning />,
  },
  {
    path: "/services/immediate-financing-arrangement-ifa",
    element: <IfaStrategy />,
  },
];
